import React from 'react'
import StagesManager from '../components/StagesManager';
import LoginFirstStep from "./Authentication/LoginFirstStep";
import LoginCodeStep from "./Authentication/LoginCodeStep";
import LoginPasswordStep from "./Authentication/LoginPasswordStep";
import LoginInfoStep from "./Authentication/LoginInfoStep";
import LoginWelcomeStep from "./Authentication/LoginWelcomeStep";
import HttpServices from '../utils/Http.services';
import { checkTranslation, getToken, pathMaker } from '../utils/useful';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import Responsive from '../components/Responsive';
import LoginSlider from '../components/slider/LoginSlider';
import LoginReferralCheck from './Authentication/LoginReferralCheck';
import Loader from 'react-loader-spinner'
import SingleSlider from '../components/slider/SingleSlider';
import AuthenticationSlider from '../components/slider/AuthenticationSlider';

class Authentication extends React.Component {

    state = {
        pages: [
            { title: '{{lang}}Usecases', icon: '/images/icons/usecases.svg', link: 'https://info.yonnect.com/usecases', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },
            { title: '{{lang}}Utilities', icon: '/images/icons/privacy.svg', link: 'https://info.yonnect.com/utilities', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },
            { title: '{{lang}}Applets', icon: '/images/icons/business.svg', link: 'https://info.yonnect.com/applets', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },
            { title: '{{lang}}About us', icon: '/images/icons/aboutus.svg', link: 'https://info.yonnect.com/aboutus', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },
            { title: '{{lang}}Academy', icon: '/images/icons/usecases.svg', link: 'https://info.yonnect.com/academy', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },
            { title: '{{lang}}Newsroom', icon: '/images/icons/newsroom.svg', link: 'https://info.yonnect.com/newsroom', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },
            { title: '{{lang}}developers', icon: '/images/icons/usecases.svg', link: 'https://info.yonnect.com/developers', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },
            { title: '{{lang}}Advertising', icon: '/images/icons/business.svg', link: 'https://info.yonnect.com/advertising', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },
            { title: '{{lang}}Contact Us', icon: '/images/icons/aboutus.svg', link: 'https://info.yonnect.com/contactus', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },
        ],
        settings: { indicatorType: 'phone', mode: 'login', loginWithCode: false, passwordRequired: true },
        data: { 'userIndicator': '0001' },
        items: [
            { loaderColor: '#7D7AFF', bg: 'linear-gradient(90deg, #5856D6, #7D7AFF)', title: 'Commerce Applet', des: 'You can connect your store to commerce applet to manage your sales.' },
            { loaderColor: '#96C723', bg: 'linear-gradient(90deg, #6E9318, #96C723)', title: 'Commerce Applet', des: 'You can connect your store to commerce applet to manage your sales.' },
            { loaderColor: '#60398f', bg: 'linear-gradient(90deg, #50497f, #60398f)', title: 'Commerce Applet', des: 'You can connect your store to commerce applet to manage your sales.' },
            { loaderColor: '#a912eb', bg: 'linear-gradient(90deg, #7b00f7, #a912eb)', title: 'Commerce Applet', des: 'You can connect your store to commerce applet to manage your sales.' },
            { loaderColor: '#677dc4', bg: 'linear-gradient(90deg, #007aff, #677dc4)', title: 'Commerce Applet', des: 'You can connect your store to commerce applet to manage your sales.' },
            { loaderColor: '#246AC7', bg: 'linear-gradient(90deg, #184D94, #246AC7)', title: 'Commerce Applet', des: 'You can connect your store to commerce applet to manage your sales.' },

        ],
        isLoading: false,
        timerPercentage: 0,
        active: 0,
        slideTimer: 2000
    }


    async componentDidMount() {
        this.setTimer()
        this.setState({ isLoading: true })
        try {
            this.getCountryFromIP()
        } catch (error) {
            this.goToInitPage()
        }
    }

    getPublicIP = async () => {
        try {
            const response = await fetch('https://api64.ipify.org?format=json');
            console.log('ttttttt2')

            const data = await response.json();
            console.log('ttttttt3')
            return data.ip; // Returns public IP
        } catch (error) {
            this.goToInitPage()

        }
    };

    // Fetch country from public IP
    getCountryFromIP = async () => {
        try {
            const publicIP = await this.getPublicIP();
            console.log('ttttttt4')
            let response
            try {
                response = await fetch(`https://ipapi.co/${publicIP}/json/`);

            } catch {
                this.goToInitPage()
            }
            console.log('ttttttt5')
            const data = await response.json();
            console.log('ttttttt6')
            if (data.error) {
                this.goToInitPage()

                this.setState({ location: null, error: data.reason });
            } else {
                let countryCallingCode = data.country_calling_code
                countryCallingCode = String(countryCallingCode).replace('+', '')
                let initData = this.state.data
                initData['userIndicator'] = countryCallingCode
                console.log('ttttttt1')
                this.setState({ data: initData }, () => {

                    this.goToInitPage()
                })
                this.setState({ location: `Public IP: ${publicIP}, Country: ${data.country_name}`, error: null });
            }
        } catch (error) {
            this.setState({ location: null, error: error.message });
        }
    };

    goToInitPage = () => {
        this.setState({ isLoading: false }, () => {
            this.changeStage('init')
        })
    }

    checkLogin() {
        if (this.props.user.loggedin) {
            if (getToken()) {
                this.props.history.push(pathMaker('/me'))
            }
        }
    }

    userCheck = (cb) => {
        let data = this.state.data
        if (data.userIndicator && data.userIndicator.length >= 5) {
            HttpServices.request("userCheck", data, (fetchResult, fetchError) => {
                if (fetchError) { if (cb) { cb(null, fetchError.message) }; return }
                console.log('fetchResultww', fetchResult, this.state.settings)
                this.setData({ exist: fetchResult.exist })
                if (fetchResult.exist && !this.state.settings.loginWithCode) {
                    if (this.state.settings?.mode == 'forgotPassword') {
                        this.postForgotPassword(() => {
                            this.changeStage('code')
                        })
                    } else {
                        this.changeStage('password')
                    }
                } else {
                    this.changeStage('code')
                }
                if (cb) { cb() }
            })
        } else {
            if (this.state.settings.indicatorType === 'phone') {
                cb(null, { userIndicator: "{{lang}}errors.phoneLength" })
            }
            if (this.state.settings.indicatorType === 'email') {
                cb(null, { userIndicator: "{{lang}}errors.emailPattern" })
            }
        }
    }

    userAuthenticate = (cb) => {

        let data = this.state.data
        if (data.userIndicator && data.userIndicator.length >= 0 && data.code && String(data.code).length >= 4) {
            HttpServices.request('userAuthenticate', data, (fetchResult, fetchError) => {
                if (fetchError) { if (cb) { cb(null, fetchError.message) }; return }
                if (this.state.data.exist || this.state.settings.mode === "forgotPassword") {
                    if (this.state.settings.passwordRequired || this.state.settings.mode === "forgotPassword") {
                        this.changeStage('password')
                    } else {
                        this.loginDone(fetchResult)
                    }
                } else {
                    this.changeStage('info')
                }
                if (cb) { cb() }
            })
        } else {
            cb(null, { code: "{{lang}}errors.codeLength" })
        }
    }



    postCode = (cb) => {
        if (this.state.data.exist) {
            this.userAuthenticate(cb)
        } else {
            this.userSignupVerifyCode(cb)
        }
    }





    userSignupVerifyCode = (cb) => {

        let data = this.state.data
        if (data.userIndicator && data.userIndicator.length >= 0 && data.code && String(data.code).length >= 4) {
            HttpServices.request("userSignupVerifyCode", data, (fetchResult, fetchError) => {
                if (fetchError) { if (cb) { cb(null, fetchError.message) }; return }
                if (this.state.data.exist || this.state.settings.mode === "forgotPassword") {
                    if (this.state.settings.passwordRequired || this.state.settings.mode === "forgotPassword") {
                        this.changeStage('password')
                    } else {
                        // LOGIN
                        this.loginDone(fetchResult)
                    }
                } else {
                    this.changeStage('referral')
                }
                if (cb) { cb() }
            })
        } else {
            cb(null, { code: "{{lang}}errors.codeLength" })
        }
    }


    userCheckPassword = (cb) => {

        let data = this.state.data
        if (data.userIndicator && data.userIndicator.length >= 0) {
            HttpServices.request(this.state.settings.mode === 'forgotPassword' ? "postNewPassword" : 'userCheckPassword', data, (fetchResult, fetchError) => {
                if (fetchError) { if (cb) { cb(null, fetchError.message) }; return }
                this.loginDone(fetchResult)
                if (cb) { cb() }
            })
        } else {
            cb(null, { code: "{{lang}}errors.codeLength" })
        }
    }


    userPostInfo = (cb) => {
        let data = this.state.data
        if (data.userIndicator && data.userIndicator.length >= 0 && data.code && String(data.code).length >= 4) {
            HttpServices.request("userPostInfo", data, (fetchResult, fetchError) => {
                if (fetchError) { if (cb) { cb(null, fetchError.message) }; return }
                this.loginDone(fetchResult)
                if (cb) { cb() }
            })
        } else {
            cb(null, { code: "{{lang}}errors.codeLength" })
        }
    }




    postForgotPassword = (cb) => {
        let data = this.state.data
        if (data.userIndicator && data.userIndicator.length >= 5) {

            HttpServices.request("postForgotPassword", data, (fetchResult, fetchError) => {
                if (fetchError) { if (cb) { cb(null, fetchError.message) }; return }
                this.changeStage('code', () => {
                    // setTimeout(() => {
                    let settings = this.state.settings
                    settings.mode = 'forgotPassword'

                    this.setState({ settings }, () => {
                        // }, 1000);
                    })
                })
                if (cb) { cb() }
            })
        } else {
            if (this.state.settings.indicatorType === 'phone') {
                cb(null, { userIndicator: "{{lang}}errors.phoneLength" })
            }
            if (this.state.settings.indicatorType === 'email') {
                cb(null, { userIndicator: "{{lang}}errors.emailPattern" })
            }
        }
    }


    loginDone = (data) => {
        this.setData(data.user)
        if (data.auth?.token) {
            this.props.actions.setUser(data.user, data.auth, true)
            this.changeStage('welcome')
        }
    }


    setData = (data, cb) => {
        let newData = this.state.data
        for (const [key, value] of Object.entries(data)) {
            newData[key] = value
        }
        this.setState({ data: newData }, () => {
            if (cb) { cb() }
        })
    }



    changeStage = (newStage, cb) => {
        if (this.stageManager) {
            this.stageManager.changeStage(newStage, cb)
        }
    }

    lastStage = () => {
        if (this.stageManager) {
            this.stageManager.lastStage()
        }
    }

    setColor = (bg) => {
        this.setState({ bg })
    }



    // slider
    handleClick = (plus = 1) => {
        var active = this.state.active;

        active = active + plus

        if (active > this.state.items?.length - 1) {
            active = 0
        }

        if (active < 0) {
            active = this.state.items?.length - 1
        }


        this.setState({
            active: active
        }, () => {

            clearInterval(this.timer)
            this.setState({ timerPercentage: 0, notransition: true }, () => {
                setTimeout(() => {
                    this.setState({ notransition: false })
                    this.setTimer()
                }, 10);
            })
        });

    }




    setTimer = () => {

        let seconds = this.state.slideTimer / 5
        this.timer = setInterval(() => {
            if (this.state.timerPercentage < 100) {
                let timerPercentage = this.state.timerPercentage + 5
                this.setState({ timerPercentage })
            } else {
                this.handleClick()
            }
        }, seconds);

    }

    render() {
        return (
            <div className="w-100  Authentication window-content-radius h-100 d-flex flex-column" style={{}}>

                <div className='d-flex flexc h-100' style={{ minHeight: this.props.height }}>
                    <Responsive width={this.props.width} height={'100%'} media={{ xs: '100%', md: "7", lg: "5" }}>
                        <div className='w-100 h-100  scroll-no-scrollbar'>
                            <div className='main-content w-100' style={{ minHeight: '100%' }}>
                                {this.state.isLoading ? (
                                    <div className='w-100 h-100 flexcc' style={{ paddingTop: 150 }}>
                                        <AuthenticationSlider slideTimer={2000} buttons={false} active={this.state.active}>
                                            {this.state.items.map((prop, index) => {
                                                return (
                                                    <Loader
                                                        type={"TailSpin"}
                                                        color={prop.loaderColor}
                                                        height={50}
                                                        width={50}
                                                    />
                                                )
                                            })}
                                        </AuthenticationSlider>
                                    </div>
                                ) : (
                                    <div>
                                        <StagesManager ref={el => this.stageManager = el} >
                                            <LoginFirstStep textColor={this.state.bg} language={this.props.language} initData={this.state.data} setData={this.setData} width={this.props.width} height={this.props.height} settings={this.state.settings} userCheck={this.userCheck} stage={1} stageName={'init'} info={this.state.loginInfo} type={'phone'} />
                                            <LoginCodeStep textColor={this.state.bg} language={this.props.language} initData={this.state.data} setData={this.setData} width={this.props.width} height={this.props.height} settings={this.state.settings} userCheck={this.userCheck} postCode={this.postCode} stage={1} stageName={'code'} />
                                            <LoginPasswordStep textColor={this.state.bg} language={this.props.language} initData={this.state.data} setData={this.setData} width={this.props.width} height={this.props.height} settings={this.state.settings} userCheckPassword={this.userCheckPassword} postForgotPassword={this.postForgotPassword} stage={2} stageName={'password'} />
                                            <LoginReferralCheck textColor={this.state.bg} language={this.props.language} initData={this.state.data} setData={this.setData} width={this.props.width} height={this.props.height} settings={this.state.settings} userPostInfo={this.userPostInfo} stage={3} stageName={'referral'} />
                                            <LoginInfoStep textColor={this.state.bg} language={this.props.language} initData={this.state.data} setData={this.setData} width={this.props.width} height={this.props.height} settings={this.state.settings} userPostInfo={this.userPostInfo} stage={3} stageName={'info'} />
                                            <LoginWelcomeStep textColor={this.state.bg} language={this.props.language} initData={this.state.data} settings={this.state.settings} width={this.props.width} height={this.props.height} goToInitPage={this.goToInitPage} stage={4} stageName={'welcome'} changeWindow={this.props.changeWindow} closeWindow={this.props.closeWindow} />
                                        </StagesManager>
                                    </div>
                                )}
                            </div>
                            <div className='w-100 px-4 pt-5 d-flex flex-wrap color-dark-blue-1 position-relative'>

                                {this.state.pages.map((page, index) => {
                                    return (
                                        <Responsive width={this.props.width} media={{ xs: "12", s: "6", md: "6", lg: "6" }} key={index} >
                                            <div className={'list-item px-1'}>
                                                <a href={page.link} target="_blank">
                                                    <div className='d-flex align-items-start pb-5'>
                                                        <img className='prd-3' src={page.icon} />
                                                        <div>
                                                            <p className='text-semibold text-normal '>{checkTranslation(page.title)}</p>
                                                            <p className='text-smaller mt-1 color-dark-blue-1'>{checkTranslation(page.description)}</p>
                                                        </div>
                                                    </div>
                                                </a>

                                            </div>
                                        </Responsive>
                                    )
                                })}
                            </div>
                        </div>
                    </Responsive>


                    <Responsive width={this.props.width} height={'100%'} media={{ xs: 'none', md: "5", lg: "7" }} style={{}}>
                        <div className='w-100 h-100' style={{ height: this.props.height, }}>
                            {/* <img className='w-100 h-100' style={{ objectFit: "cover", }} src='/images/login.jpg' /> */}
                            <LoginSlider setColor={this.setColor} items={this.state.items} handleClick={this.handleClick} active={this.state.active} />
                        </div>
                    </Responsive>
                </div>

                <Responsive width={this.props.width} height={"100%"}>

                    <div className='second-content position-relative'>

                        <div className='w-100  d-flex flex-wrap color-dark-blue-1'>
                            <div className='w-100 h-100 position-absolute overflow-hidden' >
                                <div style={{ height: 1000, width: 1000, zIndex: 0, position: 'absolute', top: -100, left: -500, background: 'radial-gradient(67.22% 50% at 50% 50%, #EAF1F1 0%, #ffffff 80%)' }}></div>

                                <div style={{ height: 1000, width: 1000, zIndex: 0, position: 'absolute', top: -200, left: 450, background: 'radial-gradient(48.02% 35.72% at 50% 50%, #E9DEDE 0%, #fff 80%)' }}> </div>
                            </div>

                        </div>
                    </div>


                </Responsive>



            </div>
        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Authentication);
